import * as React from "react";
const SvgFiRrHammerWar = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-hammer-war_svg__a)">
      <path
        fill="#062147"
        d="M23.961 13.848c-.176-1.254-.912-2.326-1.952-2.9l-2.962-1.964-.451-2.01a1.99 1.99 0 0 0-1.569-1.568l-2.012-.452-1.922-2.895a3.96 3.96 0 0 0-2.94-2.02A3.96 3.96 0 0 0 6.77 1.172L5.172 2.77a3.97 3.97 0 0 0-1.133 3.383c.176 1.254.912 2.326 1.948 2.898l3.758 2.518.637.637-6.088 6.088a3.004 3.004 0 0 0-4.293 2.707c0 1.654 1.346 3 3 3a3.004 3.004 0 0 0 2.707-4.293l6.088-6.088.637.637 2.474 3.686a3.97 3.97 0 0 0 2.941 2.02q.285.039.567.04a3.96 3.96 0 0 0 2.816-1.174l1.598-1.598a3.97 3.97 0 0 0 1.132-3.383M3 22a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m7.255-12.497L7.03 7.346a1.99 1.99 0 0 1-1.01-1.47 1.99 1.99 0 0 1 .566-1.692l1.598-1.598a1.98 1.98 0 0 1 1.692-.566c.627.088 1.163.456 1.511 1.076L13.49 6.27zm1.54 1.288 3.662-3.66 1.179.234.235 1.178-3.662 3.662zm9.619 5.025-1.598 1.598a2 2 0 0 1-1.692.566c-.627-.088-1.163-.456-1.514-1.08l-2.114-3.155 3.234-3.234 3.239 2.144c.554.308.922.844 1.01 1.471a1.99 1.99 0 0 1-.566 1.691z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-hammer-war_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHammerWar;
